// src/hooks/useSEO.js
// Met à jour <title>, description, canonical, robots et Open Graph à chaque
// changement de page dans l'application (navigation côté client).
import { useEffect } from "react";
import seoPages, { SITE_URL } from "../seo/seoPages";

function setMeta(attr, key, value) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/**
 * useSEO("/blog") pour une page déclarée dans seoPages.js,
 * ou useSEO("/blog/mon-article", { title, description }) pour une page dynamique.
 */
export default function useSEO(path, override = {}) {
  const base = seoPages[path] || {};
  const title = override.title || base.title;
  const description = override.description || base.description;
  const noindex = override.noindex ?? base.noindex ?? false;

  useEffect(() => {
    if (!title) return;
    const url = SITE_URL + (path === "/" ? "/" : path);

    document.title = title;
    setMeta("name", "description", description);
    setMeta("name", "robots", noindex ? "noindex, follow" : "index, follow");
    setCanonical(url);
    setMeta("property", "og:url", url);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
  }, [path, title, description, noindex]);
}
